import { KeycloakProfile } from 'keycloak-js';
import { Component, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromUser from '../../../core/state/user/user.reducer';
import Keycloak from 'keycloak-js';
import { MenuItem } from 'primeng/api';

@Component({
    selector: 'app-header-profile',
    templateUrl: './header-profile.component.html',
    standalone: false
})
export class HeaderProfileComponent implements OnInit {
  private keycloak = inject(Keycloak);

  authenticated = false;

  profile: KeycloakProfile | null = null;

  items: MenuItem[] = [
  ];

  constructor(
    private store: Store<fromUser.UserState>
  ) {
  }

  ngOnInit() {
    this.authenticated = this.keycloak.authenticated ?? false;
    this.keycloak.loadUserProfile().then(profile => {
      this.profile = profile;
    });
  }

  getFullName() {
    return this.profile?.firstName + ' ' + this.profile?.lastName;
  }

  login(){
    this.keycloak.login();
  }
}
